import styled from 'styled-components';

const Product = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  > * {
    font-family: "Avenir Light", "Arial", sans-serif;
    line-height: normal;
    color: #999;
    text-overflow: ellipsis;
    overflow: hidden;
    letter-spacing: inherit;
    text-transform: inherit;
    margin: inherit;
  }
  color: ${({ bright }) => (bright ? '#999;' : '#000000')};
`;

export default Product;
